import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { UiRouterResolverFactory } from '@client/app/shared/ui-router/ui-router-resolver-factory';
import { Component } from '@angular/core';
import { PagesPolicyComponent } from '@client/app/pages/policy/pages-policy.component';
import { PagesPolicyPagesComponent } from '@client/app/pages/policy/pages/pages-policy-pages.component';
import { PolicyPoliciesComponent } from '@client/app/pages/policy/policies/policies.component';
import {
    PagesPolicyIgnoredPagesComponent,
} from '@client/app/pages/policy/pages-with-ignored-checks/pages-with-ignored-checks.component';

@Component({
    selector: 'base-policy',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BasePolicyComponent {}

export const POLICY_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.policy',
        url: '/policies',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BasePolicyComponent,
            },
        },
        resolve: UiRouterResolverFactory.createActiveFeatureStateResolver({
            token: 'hasAccessPolicyFeatures',
            pureFeatures: ['global_policy', 'policies_all'],
        }),
        data: {
            sidebar: 'policy',
        },
    },
    {
        name: 'base.customer.domain.policy.dashboard',
        url: '/summary',
        data: {
            title: 'Acquia Web Governance - Policies',
        },
        views: {
            'content@base.customer.domain.policy': {
                component: PagesPolicyComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.policy.pages',
        url: '/pages',
        data: {
            title: 'Acquia Web Governance - Content With Policy Matches',
        },
        views: {
            'content@base.customer.domain.policy': {
                component: PagesPolicyPagesComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.policy.policies',
        url: '/policies?search&policy_id&tab',
        params: {
            search: { dynamic: true },
            policy_id: { dynamic: true },
            tab: { dynamic: true },
        },
        data: {
            title: 'Acquia Web Governance - Policy List',
        },
        views: {
            'content@base.customer.domain.policy': {
                component: PolicyPoliciesComponent,
            },
        },
    },
    {
        name: 'base.customer.domain.policy.ignored-pages',
        url: '/pages-with-ignored-checks',
        data: {
            title: 'Acquia Web Governance - Policy Pages With Ignored Checks',
        },
        views: {
            'content@base.customer.domain.policy': {
                component: PagesPolicyIgnoredPagesComponent,
            },
        },
    },
];
